export const REVIEW_WORKFLOW_ERROR_KEYS: Record<string, string> = {
  "REVIEW-WORKFLOW-NOT-FOUND": "tasks.errors_workflow_not_found",
  "REVIEW-WORKFLOW-NOT-APPLICABLE": "tasks.errors_workflow_not_applicable",
  REVIEW_WORKFLOW_INSTANCE_NOT_FOUND: "tasks.errors_instance_not_found",
  REVIEW_WORKFLOW_INSTANCE_ALREADY_ASSIGNED: "tasks.errors_workflow_already_assigned",
  REVIEW_WORKFLOW_AUTO_APPLIED_CANNOT_BE_DETACHED: "tasks.errors_workflow_auto_applied_cannot_be_detached",
  REVIEW_WORKFLOW_CATEGORY_MISMATCH: "tasks.errors_category_mismatch",
  REVIEW_WORKFLOW_TASK_ALREADY_SUBMITTED: "tasks.errors_task_already_submitted",
  REVIEW_WORKFLOW_TASK_ARCHIVED: "tasks.errors_task_archived",
  REVIEW_WORKFLOW_UNKNOWN_STEP: "tasks.errors_unknown_step",
  REVIEW_WORKFLOW_STEP_NOT_EDITABLE: "tasks.errors_step_not_editable",
  REVIEW_WORKFLOW_STEP_NOT_EDITABLE_ANYMORE: "tasks.errors_step_not_editable_anymore",
  REVIEW_WORKFLOW_ASSIGNEE_NOT_IN_POOL: "tasks.errors_assignee_not_in_pool",
  REVIEW_WORKFLOW_ASSIGNEE_UNAVAILABLE: "tasks.errors_assignee_unavailable",
  REVIEW_WORKFLOW_HAS_NO_STEPS: "tasks.errors_workflow_has_no_steps",
  REVIEW_WORKFLOW_NOT_A_CUSTOMER_TASK: "tasks.errors_not_a_customer_task",
  REVIEW_WORKFLOW_NOT_AN_INTERNAL_TASK: "tasks.errors_not_an_internal_task",
  REVIEW_WORKFLOW_STEP_ASSIGNEES_REQUIRED: "tasks.errors_step_assignees_required",
  REVIEW_WORKFLOW_STEP_LAST_APPROVER_REQUIRED: "tasks.errors_last_approver_required",
  REVIEW_WORKFLOW_STEP_ALREADY_SETTLED: "tasks.errors_step_already_settled",
  REVIEW_WORKFLOW_INSTANCE_ALREADY_COMPLETED: "tasks.errors_instance_already_completed",
  REVIEW_WORKFLOW_STEP_COMMENT_REQUIRED: "tasks.errors_step_comment_required",
  REVIEW_WORKFLOW_SIGNING_STEP_NOT_SUPPORTED: "tasks.errors_signing_step_not_supported",
  REVIEW_WORKFLOW_SUBMIT_FAILED: "tasks.errors_submit_failed",
  REVIEW_WORKFLOW_QUESTIONNAIRE_INCOMPLETE: "tasks.errors_questionnaire_incomplete",
  REVIEW_WORKFLOW_QUESTIONNAIRE_SESSION_NOT_IDENTIFIED: "tasks.errors_questionnaire_session_not_identified",
  REVIEW_WORKFLOW_NO_ACTIVE_STEP: "tasks.errors_no_active_step",
  REVIEW_WORKFLOW_QUESTIONNAIRE_ASSIGNEES_ONLY: "tasks.errors_questionnaire_assignees_only",
  REVIEW_WORKFLOW_TASK_ACTION_BLOCKED_WHILE_RUNNING: "tasks.errors_task_action_blocked_while_running",
  REVIEW_WORKFLOW_NOTIFY_RECIPIENTS_REQUIRED: "tasks.errors_notify_recipients_required",
  REVIEW_WORKFLOW_TASK_ACTION_REQUIRES_TASK_OWNER: "tasks.errors_requires_task_owner",
  REVIEW_WORKFLOW_STEP_ACTION_REQUIRES_ASSIGNEE: "tasks.errors_requires_step_assignee",
  REVIEW_WORKFLOW_STEP_ACTION_REQUIRES_REJECTION_ASSIGNEE: "tasks.errors_requires_rejection_assignee",
  REVIEW_WORKFLOW_STEP_NOT_ACTIONABLE: "tasks.errors_step_not_actionable",
  REVIEW_WORKFLOW_STEP_ALREADY_ACTED: "tasks.errors_step_already_acted",
  REVIEW_WORKFLOW_STEP_NOT_FOUND: "tasks.errors_step_not_found",
  REVIEW_WORKFLOW_TASK_NO_CUSTOMER_ACCESS: "tasks.errors_no_customer_access",
  REVIEW_WORKFLOW_TASK_QUESTIONNAIRE_COLLECTS_SIGNATURES: "tasks.errors_questionnaire_collects_signatures",
  REVIEW_WORKFLOW_SIGNING_ALREADY_ISSUED: "tasks.errors_signing_already_issued",
  REVIEW_WORKFLOW_SIGNING_NOT_RETRYABLE: "tasks.errors_signing_not_retryable",
  REVIEW_WORKFLOW_SIGNING_STILL_SENDING: "tasks.errors_signing_still_sending",
  REVIEW_WORKFLOW_SIGNING_NO_SIGNERS: "tasks.errors_signing_no_signers",
  REVIEW_WORKFLOW_SIGNING_NO_DOCUMENT: "tasks.errors_signing_no_document"
};

export const WORKFLOW_ASSIGNMENT_RESPONSE_CODE = {
  ASSIGNEES_REQUIRED: "REVIEW-WORKFLOW-ASSIGNEES-REQUIRED",
  INVALID_ASSIGNEES: "REVIEW-WORKFLOW-INVALID-ASSIGNEES"
} as const;

export function reviewWorkflowErrorKey(error: unknown, fallbackKey: string): string {
  const code = (error as { error?: { code?: string } } | null | undefined)?.error?.code;
  return (code && REVIEW_WORKFLOW_ERROR_KEYS[code]) ?? fallbackKey;
}
